<template>
    <div id="fxh_download">
        <div class="top_part">
            <img class="top_part_back" src="@/assets/download/newback.png" alt="">
            <img class="top_logo" src="@/assets/download/back-logo.png" alt="">
            <h1>金果子<br/>网格量化工具</h1>
            <h2>克服投资情绪<br/>轻松穿越牛熊</h2>
        </div>
        <!-- <div class="code_box">
            <span class="tip">我的邀请码：<span>{{myCode}}</span></span>
            <span class="copy my_code" @click="copyCode">复制</span>
        </div> -->
        <div class="button_box clearfix">
            <button id="iosProDownBtn" @click="goUserGuide">iOS 专业版</button>
            <button id="anDownloadButton">安卓 专业版</button>
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>

<script>
const Base64 = require('js-base64').Base64
import Clipboard from 'clipboard'
export default {
    name: 'FxhDown',
    data() {
        return {
            maskViewShow: false,
            message: '',
            alertShow: false,
            myCode: '',
            ShareInstall: ShareInstall
        }
    },
    mounted(){
        var isTest = this.$MyAxios.axiosInstance.defaults.baseURL == 'https://test.api.jinguozi.net' ? true : false;
        var data = this.ShareInstall.parseUrlParams();//shareinstall.js中提供的工具函数，解析url中的所有查询参数
        if(data.d){
            this.myCode = Base64.decode(data.d).split('_')[1];
        }else{
            this.showAlert('缺少参数')
        }
        var self = this;
        new this.ShareInstall({
            appKey : isTest ?  "KABK6HE72FEHRE" : "KRBK6HE72KBBK7",      //金果子PRO 正式环境KEY
           
            /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
            preferWakeup:true,
            /*可选参数，微信中直接跳下载*/
            // weChatdownload:true,

            // timeout: 10000,
            onready : function() {
                //shareinstall已成功回调
                const m = this;
                // var iosProButton = document.getElementById("iosProDownBtn");
                var androidButton = document.getElementById("anDownloadButton");
                // iosProButton.style.visibility = "visible";
                androidButton.style.visibility = "visible";

                //用户点击某个按钮时(假定按钮id为downloadButton)，安装app
                // iosProButton.onclick = function() {
                //     let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
                //     if(isWeChat){
                //         self.maskViewShow = true;
                //         return
                //     }
                //     m.wakeupOrInstall({downloadType: isTest ? 1 : 0});
                // }

                androidButton.onclick = function() {
                    let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
                    if(isWeChat){
                        self.maskViewShow = true;
                        return
                    }
                    m.wakeupOrInstall({downloadType: isTest ? 1 : 0});
                }
            }
        }, data);
    },
    methods: {
        copyCode() {
            let code = this.myCode
            // let code = '123'
            let clipboard = new Clipboard('.my_code', {
                text: function () {
                    return code
                }
            })
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },

        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
        
        //  ios点击去用户引导
        goUserGuide() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                let data = this.ShareInstall.parseUrlParams();
                this.$router.push({ path: 'user-guide', query: { ...data } })
			}
        }
    }
}
</script>

<style lang='less'>
#fxh_download {
    min-height: 100vh;
	width: 100%;
	background: linear-gradient(180deg,#fff6e8, #ffffff);
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .code_box {
        font-size: 28px;
        color: #9598A6;
        width: 430px;
        height: 62px;
        margin: 0 auto;
        margin-bottom: 60px;
        background: #ffffff;
        box-shadow: 0px 10px 10px 0px rgba(255,164,31,0.10); 
        line-height: 62px;
        span {
            vertical-align: middle;
            margin-right: 8px;
            line-height: 40px;
        }
        .tip {
            margin-right: 8px;
        }
        .copy {
            border-radius: 8px;
            border: 1px solid #FFA41F;
            display: inline-block;
            color: #FFA41F;
            height: 36px;
            width: 70px;
            line-height: 36px;
            cursor: pointer;
            font-size: 20px;
        }
    }
    .top_part {
        width: 100%;
        height: 760px;
        // margin-bottom: 80px;
        margin-bottom: 60px;
        .top_part_back {
            width: 100%;
            height: 734px;
            position: relative;
            overflow: hidden;
        }
        .top_logo {
            height: 163px;
            width: 306px;
            left: 26px;
            top: 84px;
            position: absolute;
            z-index: 1;
        }
        h1 {
            height: 138px;
            width: 288px;
            line-height: 71px;
            font-size: 48px;
            font-weight: 600;
            color: #ffffff;
            position: absolute;
            top: 281px;
            left: 57px;
            text-align: left;
        }
        h2 {
            height: 118px;
            width: 240px;
            line-height: 62px;
            font-size: 40px;
            font-weight: 400;
            color: #ffffff;
            position: absolute;
            top: 453px;
            left: 57px;
            text-align: left;
        }
    }
    .button_box {
        position: relative;
    }
    button {
        height: 88px;
        width: 690px;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 8px;
        background: #FF811F;
        // box-shadow:0px 6px 16px rgba(255,102,0,0.3);
        // position: absolute;
        margin-bottom: 40px;
        color: #ffffff;
        font-size: 32px;
        font-weight: bold;
        &:nth-of-type(1) {
            left: 40px;
        }
        // &:nth-of-type(2) {
        //     left: 50%;
        //     transform: translateX(-50%);
        // }
        &:nth-of-type(2) {
            right: 40px;
            // font-size: 26px;
        }
        &.disable {
            background: gray;
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
@keyframes moveLeft
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@-webkit-keyframes moveLeft /*Safari and Chrome*/
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@keyframes moveRight
{
	from {left: -200vw;}
	to {left: 0px;}
}

@-webkit-keyframes moveRight /*Safari and Chrome*/
{
	from {left: -200vw;}
	to {left: 0px;}
}
</style>
